import React from 'react';

const RoundSpecialDetails = ({ matches }) => (
  <div className="table-responsive m-t-30">
    <table className="match">
      <thead className="thead--green">
        <tr>
          <th>Total Score</th>
          <th>Minute</th>
          <th>Match</th>
        </tr>
      </thead>
      <tbody>
        {matches.map((match) => (
          <tr key={match.matchMinute}>
            <td>{match.totalScorePerMinute}</td>
            <td>{match.matchMinute}&apos;</td>
            <td>
              {match.matches.map((m) => (
                <div key={m.matchId} className="round-special team-container">
                  <div className="home-team">{m.homeTeam}</div>
                  <div className="score">{m.homeScore} - {m.awayScore}</div>
                  <div className="away-team">{m.awayTeam}</div>
                </div>
              ))}
            </td>
          </tr>))
        }
      </tbody>
    </table>
  </div>
);

export default RoundSpecialDetails;